import { render, staticRenderFns } from "./YunoRedirect.vue?vue&type=template&id=105ac779"
import script from "./YunoRedirect.vue?vue&type=script&lang=js"
export * from "./YunoRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports